import { Col, Input, Radio, Row, Space } from 'antd';
import React, { useState } from 'react';

const DescuentoRecargoInput = ({ value = {}, onChange }) => {
  const [number, setNumber] = useState();
  const [tipo, setTipo] = useState('descuento');
  const triggerChange = (changedValue) => {
    onChange?.({
      number,
      tipo,
      ...value,
      ...changedValue
    });
  };
  const onNumberChange = (e) => {
    const newNumber = e.target.value;
    if (Number.isNaN(number)) {
      return;
    }
    if (!('number' in value)) {
      setNumber(newNumber);
    }
    triggerChange({
      number: newNumber
    });
  };
  const onTipoChange = (event) => {
    if (!('tipo' in value)) {
      setTipo(event.target.value);
    }
    triggerChange({
      tipo: event.target.value
    });
  };
  return (
    <Row gutter={[16, 16]} align="middle">
      <Col>
        <Input
          value={value.number || number}
          onChange={onNumberChange}
          style={{
            width: 100
          }}
          placeholder="--"
          min={0}
          max={100}
          step={0.1}
          type="number"
          suffix="%"
        />
      </Col>
      <Col>
        <Radio.Group
          value={value.tipo || tipo}
          style={{
            width: 200,
            margin: '0 8px'
          }}
          onChange={onTipoChange}
          // style={{
          //   width: 60
          // }}
        >
          <Space direction="horizontal">
            <Radio value="descuento">Descuento</Radio>
            <Radio value="recargo">Recargo</Radio>
          </Space>
        </Radio.Group>
      </Col>
    </Row>
  );
};

export default DescuentoRecargoInput;
